import Comentario from "./Comentario";

class Tarea {
    constructor({
                    id = null,
                    title = '',
                    description = '',
                    columnId = '',
                    priority = 'medio', // 'bajo' | 'medio' | 'alto'
                    assignee = '',
                    dueDate = null,     // 'YYYY-MM-DD'
                    comments = [],
                } = {}) {
        this.id = id
        this.title = title
        this.description = description
        this.columnId = columnId
        this.priority = priority
        this.assignee = assignee
        this.dueDate = dueDate
        this.comments = comments.map((c) => c instanceof Comentario ? c : Comentario.from(c))
    }

    static from(api) {
        if (!api) return new Tarea()
        return new Tarea({
            id: api.id,
            title: api.titulo ?? '',
            description: api.descripcion ?? '',
            columnId: api.columna_id ?? '',
            priority: api.prioridad ?? 'medio',
            assignee: api.asignado_id ?? '',
            dueDate: api.vencimiento ?? null,
            comments: Array.isArray(api.comentarios) ? api.comentarios.map(Comentario.from) : [],
        })
    }

    toObject() {
        return {
            id: this.id ?? undefined,
            titulo: this.title,
            descripcion: this.description,
            columna_id: this.columnId,
            prioridad: this.priority,
            asignado_id: this.assignee,
            vencimiento: this.dueDate,
        }
    }
}

export default Tarea;